import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://ecoapi.aethergames.xyz"; // Your API base URL
// const API_BASE_URL = "http://localhost:3001"; // Your API base URL
// console.log("process.env.REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Access-Control-Allow-Origin": `${API_BASE_URL}`, // Reactivate before pushing
    "Access-Control-Allow-Credentials": true,
    // "Access-Control-Allow-Origin": `*`, //Allow for localhost
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",

    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add an interceptor for error handling or token management if needed
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default api;
